import { objectsRHandler } from '@/utils/objectsRHandler';

import LevelDocument from '../list/level-document';

const API_PATH = 'events/available-documents';

export const LevelDocumentsManager = {
  objects: {
    ...objectsRHandler(API_PATH, LevelDocument),

    create({ args, data }) {
      const [eventId] = args;
      const CURRENT_API_PATH = `events/${eventId}/level-documents`;
      const { create } = objectsRHandler(CURRENT_API_PATH, LevelDocument);
      return create({ data });
    },
  },
  get events() {
    const url = `events/level-documents`;
    return objectsRHandler(url, LevelDocument);
  },
};
